// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"fac9e276","453":"0098adef","781":"6b2daadf","850":"29df8344"}[chunkId] + ".chunk.js";
};